import React from "react";

const ItemExternal = ({
  item,
  setSsoRefreshTokenModal,
  setActiveSidebar,
  refreshToken,
}) => (
  <>
    <a
      target="_blank"
      href={!item.sso ? item.link : undefined}
      onClick={() => {
        if (item.sso) {
          refreshToken(item.link);
          setActiveSidebar(false);
          setSsoRefreshTokenModal(true);
        }
      }}
      style={
        item.sso
          ? { color: "inherit", cursor: "pointer" }
          : { color: "inherit" }
      }
      className="sidebar-nav-item"
      rel="noopener noreferrer"
    >
      <i className="fas fa-external-link-alt" aria-hidden="true" />
      <span>{item.title}</span>
    </a>
  </>
);

export default ItemExternal;
